import { cn } from '../../lib/utils';

export const StatCard = ({ 
  title, 
  value, 
  subtitle, 
  icon: Icon, 
  trend, 
  trendValue,
  className,
  valueClassName,
  accentColor = 'primary'
}) => {
  const accentColors = {
    primary: 'from-[#00F0FF]/20 to-transparent',
    secondary: 'from-[#7000FF]/20 to-transparent',
    success: 'from-green-500/20 to-transparent',
    warning: 'from-yellow-500/20 to-transparent',
  };

  return (
    <div className={cn("stat-card group relative", className)} data-testid="stat-card">
      {/* Accent gradient */}
      <div className={cn(
        "absolute top-0 left-0 right-0 h-1 bg-gradient-to-r rounded-t-xl",
        accentColor === 'primary' && "from-[#00F0FF] to-[#7000FF]",
        accentColor === 'secondary' && "from-[#7000FF] to-[#00F0FF]",
        accentColor === 'success' && "from-green-400 to-green-600",
        accentColor === 'warning' && "from-yellow-400 to-orange-500"
      )} />
      
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <p className="text-sm text-muted-foreground font-medium mb-1">{title}</p>
          <p className={cn("text-2xl md:text-3xl font-bold tracking-tight", valueClassName)}>
            {value}
          </p>
          {subtitle && (
            <p className="text-xs text-muted-foreground mt-1">{subtitle}</p>
          )}
          {trend && (
            <div className={cn(
              "flex items-center gap-1 mt-2 text-xs font-medium",
              trend === 'up' && "text-green-400",
              trend === 'down' && "text-red-400"
            )}>
              <span>{trend === 'up' ? '↑' : '↓'}</span>
              <span>{trendValue}</span>
            </div>
          )}
        </div>
        {Icon && (
          <div className={cn(
            "p-3 rounded-xl bg-gradient-to-br",
            accentColors[accentColor]
          )}>
            <Icon className={cn(
              "w-6 h-6",
              accentColor === 'primary' && "text-[#00F0FF]",
              accentColor === 'secondary' && "text-[#7000FF]",
              accentColor === 'success' && "text-green-400",
              accentColor === 'warning' && "text-yellow-400"
            )} />
          </div>
        )}
      </div>
    </div>
  );
};
